import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, extractError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("كلمة المرور يجب أن تكون 8 أحرف على الأقل"); return; }
    if (pw !== confirm) { toast.error("كلمتا المرور غير متطابقتين"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("تم تحديث كلمة المرور، سجّل الدخول الآن");
      nav("/login");
    } catch (err) {
      toast.error(extractError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background p-4 sm:p-6">
      <div className="max-w-md sm:max-w-lg w-full space-y-6 bg-card p-6 sm:p-10 rounded-2xl border shadow-sm">
        <h1 className="text-xl sm:text-2xl font-display font-semibold">تعيين كلمة مرور جديدة</h1>
        {!token ? (
          <p className="text-destructive text-sm">الرابط غير صالح.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
            <div className="space-y-2">
              <Label>كلمة المرور الجديدة</Label>
              <Input type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password" />
            </div>
            <div className="space-y-2">
              <Label>تأكيد كلمة المرور</Label>
              <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" />
            </div>
            <Button type="submit" disabled={loading} className="w-full rounded-full" data-testid="reset-submit">
              {loading ? "جارٍ التحديث..." : "تحديث كلمة المرور"}
            </Button>
          </form>
        )}
        <div className="text-center text-sm"><Link to="/login" className="text-primary hover:underline">العودة لتسجيل الدخول</Link></div>
      </div>
    </div>
  );
}
